import { AxiosInstance } from "axios";
import BenchmarkRepository, { BenchmarkWaterTestRequest } from "./BenchmarkRepository";
import CurrentUserDetails from "../../pages/account/AccountSettingsPage/model/CurrentUserDetails";

interface BenchmarkResponse {
  success: boolean;
  message: string;
  user: CurrentUserDetails;
}

class RestBenchmarkRepository implements BenchmarkRepository {
  private axios: AxiosInstance;

  constructor(axios: AxiosInstance) {
    this.axios = axios;
  }

  attachEngineer = (engineerUuid: string): Promise<CurrentUserDetails> => {
    const endpoint = "/benchmark/engineer/attach";
    
    return this.axios
      .patch<BenchmarkResponse>(endpoint, {
        engineer_uuid: engineerUuid,
      })
      .then((response) => response.data.user);
  };

  detachEngineer = (): Promise<CurrentUserDetails> => {
    const endpoint = "/benchmark/engineer/detach";
    
    return this.axios
      .patch<BenchmarkResponse>(endpoint, {})
      .then((response) => response.data.user);
  };

  submitWaterTest = (data: BenchmarkWaterTestRequest): Promise<{ success: boolean; message: string }> => {
    const endpoint = "/benchmark/water-test";
    
    return this.axios
      .post<BenchmarkResponse>(endpoint, data)
      .then((response) => ({
        success: response.data.success,
        message: response.data.message,
      }))
      .catch((error) => {
        const message = error.response?.data?.message || "Failed to submit water test to Benchmark";
        throw new Error(message);
      });
  };
}

export default RestBenchmarkRepository;